import React, { FC } from 'react';
import { useChatData } from '@/containers/ChatContainer';
import { Spinner } from '@mofid-securities/uikit';
import PulseBadge from '@/components/PulseBadge';
import LIcon, { ILIconProps } from '@/layouts/Base/components/LIcon';
import { classnames } from '@/utils/classnames';

interface ISupportIconProps
  extends PartialKeys<Omit<ILIconProps, 'onClick'>, 'icon'> {
  iconClassName?: string;
}

const SupportIcon: FC<ISupportIconProps> = ({
  className = '',
  iconClassName = '',
  ...props
}) => {
  const { isEnabled, isLoading, toggleVisibility, totalUnread } = useChatData();

  return (
    <div className={classnames('relative', className)}>
      {!!totalUnread && <PulseBadge className="absolute right-0 top-0" />}
      <LIcon
        className={classnames(
          !isEnabled && 'pointer-events-none opacity-60 grayscale',
          iconClassName
        )}
        icon="support"
        id="home_click_chat"
        onClick={() => toggleVisibility()}
        {...props}
      >
        {isLoading && <Spinner />}
      </LIcon>
    </div>
  );
};

export default SupportIcon;
